import React from 'react';
// import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch';

export const SbSharedRefineMenuFilterCreatorComponent = props => (
    <SbSharedRefineMenuMultiSelectSearch {...props} />
);

export const SbSharedRefineMenuFilterCreator = createFragmentContainer(
    SbSharedRefineMenuFilterCreatorComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterCreator_viewer on Viewer {
                ...SbSharedRefineMenuMultiSelectSearch_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterCreator_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuMultiSelectSearch_searchBrowse
            }
        `,
    }
);
